// Tiny singleton bridging UI outside the MapContainer to the Leaflet map instance.
let _map = null;

export function registerMap(map) {
  _map = map;
}

// `zoom`: if given and the map is currently more zoomed out than this, zoom
// in to it instead of just panning — used when focusing a POI that may be
// hidden inside a marker cluster at the current zoom level.
export function panToPoint(lat, lng, { zoom } = {}) {
  if (!_map || lat == null || lng == null) return;
  if (zoom != null && _map.getZoom() < zoom) {
    _map.setView([lat, lng], zoom, { animate: true });
  } else {
    _map.panTo([lat, lng], { animate: true });
  }
}

// Fit the map to a GeoJSON LineString ([lng,lat] pairs). Used after generating
// a route so distant destinations come into view.
export function fitToGeometry(geometry) {
  const coords = geometry?.coordinates;
  if (_map && coords?.length) {
    _map.fitBounds(coords.map(([lng, lat]) => [lat, lng]), { padding: [60, 60], animate: true });
  }
}
